import { Component } from '@angular/core';
import { AuthSelectors, AuthDispatchers } from '../../store';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { Kontor } from '@store/models';

@Component({
    selector: 'app-switchoffice',
    template: `
        <app-switchoffice-ui
            [offices]="offices$ | async"
            (switchOffice)="switchOffice($event)"
            (dismiss)="dismiss()"
        ></app-switchoffice-ui>
    `,
    standalone: false
})

export class SwitchOfficeContainer {

    offices$ = this.authSelector.offices$;

    constructor(
        public activeModal: NgbActiveModal,
        private authSelector: AuthSelectors,
        private authDispatch: AuthDispatchers
    ) {}

    switchOffice(office: Kontor) {
        this.authDispatch.SwitchOffice(office.kontorId, office.kontornavn);
        this.activeModal.close();
    }

    dismiss() {
        this.activeModal.dismiss();
    }

}
